/**
 * ============================================================================
 * GENERATED FILE - Created via: pnpm run generate:wetags
 * ============================================================================
 *
 * This file was generated by the wetag library generator.
 *
 * To add new entity types or update configuration, run:
 *   pnpm run generate:wetags
 *
 * You can safely modify this file if needed, but using the generator
 * ensures consistency across all wetag libraries in the codebase.
 *
 * To add type-safe tag names, update the tags.ts file in this directory.
 * ============================================================================
 */

import { createNamespacedWetagHooksForOrg, createNamespacedWetagHooksForLocation } from '@frontend/wetags';
import type { CustomerLifecycleManagementTags } from './tags';

const CUSTOMER_LIFECYCLE_MANAGEMENT_NAMESPACE = 'customer-lifecycle-management';

export const CustomerLifecycleManagementOrg = createNamespacedWetagHooksForOrg<CustomerLifecycleManagementTags>(
  CUSTOMER_LIFECYCLE_MANAGEMENT_NAMESPACE
);

export const CustomerLifecycleManagementLocations =
  createNamespacedWetagHooksForLocation<CustomerLifecycleManagementTags>(CUSTOMER_LIFECYCLE_MANAGEMENT_NAMESPACE);
